import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
// @mui
import { styled } from '@mui/material/styles'
import {
	Grid, Link, Divider, Container, Typography, Stack,
} from '@mui/material'
// routes
import { PATH_PAGE } from '../../routes/paths'
// components
import Logo from '../../components/Logo'
import SocialsButton from '../../components/SocialsButton'
import { siteData, SOCIAL_LINKS } from '../../config'

// ----------------------------------------------------------------------

const LINKS = [
	{
		headline: 'Support',
		children: [
			{ name: 'Contact', href: PATH_PAGE.contact },
			{ name: 'Community Guidelines', href: PATH_PAGE.guidelines },
		],
	},
	{
		headline: 'Company',
		children: [
			{ name: 'Team', href: PATH_PAGE.team },
			{ name: 'Terms of Service', href: PATH_PAGE.tos },
			{ name: 'Privacy Policy', href: PATH_PAGE.privacy },
		],
	},
/* 	{
		headline: 'Contact',
		children: [
			// { name: 'hey@unreal.fun', href: '#' },
			// { name: '340 South Lemon Ave, Walnut, CA 91789', href: '#' },
			{ name: 'Made with ❤️ across the world', href: '#' },
		],
	}, */
]

const RootStyle = styled('div')(({ theme }) => ({
	position: 'relative',
	backgroundColor: theme.palette.background.default,
}))

// ----------------------------------------------------------------------

export default function MainFooter() {
	return (
		<RootStyle>
			<Divider />
			<Container sx={{ pt: 10 }}>
				<Grid
					container
					justifyContent={{ xs: 'center', md: 'space-between' }}
					sx={{ textAlign: { xs: 'center', md: 'left' } }}
				>
					<Grid item xs={12} sx={{ mb: 3 }}>
						<Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
					</Grid>
					<Grid item xs={8} md={3}>
						<Typography variant="body2" sx={{ pr: { md: 5 } }}>
							Unreal is the place where NFTs congregate for a fun, playful and productive life.
							{/* to come an play. gives those NFTs in your wallet the social superpowers they deserve. The social network of your NFTs. */}
						</Typography>

						<Stack
							direction="row"
							justifyContent={{ xs: 'center', md: 'flex-start' }}
							sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
						>
							<SocialsButton sx={{ mx: 0.5 }} links={SOCIAL_LINKS} />
						</Stack>
					</Grid>

					<Grid item xs={12} md={7}>
						<Stack
							spacing={5}
							direction={{ xs: 'column', md: 'row' }}
							justifyContent="space-between"
						>
							{LINKS.map((list) => (
								<Stack key={list.headline} spacing={2}>
									<Typography component="p" variant="overline">
										{list.headline}
									</Typography>
									{list.children.map((link) => (
										<Link
											to={link.href}
											key={link.name}
											color="inherit"
											variant="body2"
											component={RouterLink}
											sx={{ display: 'block' }}
										>
											{link.name}
										</Link>
									))}
								</Stack>
							))}
						</Stack>
					</Grid>
				</Grid>

				<Typography
					component="p"
					variant="body2"
					sx={{
						mt: 10,
						pb: 5,
						fontSize: 13,
						textAlign: { xs: 'center', md: 'left' },
					}}
				>
					© 2023 Unreal Mega Corp, Inc.
				</Typography>
			</Container>
		</RootStyle>
	)
}
